import { render, staticRenderFns } from "./RankPosition.vue?vue&type=template&id=14500b60&scoped=true&"
import script from "./RankPosition.vue?vue&type=script&lang=js&"
export * from "./RankPosition.vue?vue&type=script&lang=js&"
import style0 from "./RankPosition.vue?vue&type=style&index=0&id=14500b60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14500b60",
  null
  
)

export default component.exports